import React, { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaGlobe, FaFacebook, FaInstagram } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { fetchMyConversation, sendConversationMessage } from "../api/api";

// Same contact details as the mobile app's ContactScreen (source:
// jainfarms.com public listings) - keep these two in sync if they change.
const PHONE_NUMBERS = [
  { label: "Head Office", number: "+91 80 4709 2100" },
  { label: "Horticulture", number: "+91 77603 69689", whatsapp: "917760369689" },
];

const EMAILS = [
  { label: "General enquiries", address: "horticulture@jainfarms.com" },
  { label: "Resorts", address: "resorts@jainfarms.com" },
];

const WHATSAPP_NUMBER = "917760369689";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hello Jain Farms, ")}`;

const ADDRESS = "No. 3490, 3rd Floor, 80 Feet Road, 4th H Block, BSK 6th Stage, Bengaluru – 560062";

const SOCIALS = [
  { icon: <FaGlobe />, label: "Website", url: "https://jainfarms.com", color: "#2e7d32" },
  { icon: <FaFacebook />, label: "Facebook", url: "https://www.facebook.com/Jainfarms/", color: "#1877F2" },
  { icon: <FaInstagram />, label: "Instagram", url: "https://www.instagram.com/jainfarmsindia/", color: "#E1306C" },
  { icon: <FaWhatsapp />, label: "WhatsApp", url: WHATSAPP_URL, color: "#25D366" },
];

function SendMessageCard() {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSend = async (e) => {
    e.preventDefault();
    if (!text.trim()) {
      setError("Please type your query before sending.");
      return;
    }
    setError("");
    setSending(true);
    try {
      const conversation = await fetchMyConversation();
      await sendConversationMessage(conversation.id, text.trim());
      setSent(true);
      setText("");
    } catch (err) {
      setError(err.response?.data?.detail || "Could not send your message. Please try again.");
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div style={{ textAlign: "center", padding: "10px 0" }}>
        <div style={{ fontSize: "32px", marginBottom: "6px" }}>✅</div>
        <p style={{ fontWeight: 700, margin: "0 0 4px" }}>Your query has been received</p>
        <p style={{ color: "#666", fontSize: "13px", margin: "0 0 12px" }}>
          Our team will review it and get back to you shortly.
        </p>
        <button type="button" className="register-btn" style={{ width: "auto", padding: "8px 16px" }} onClick={() => setSent(false)}>
          Send another message
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSend}>
      <p style={{ fontSize: "12px", color: "#666", lineHeight: 1.5, marginBottom: "10px" }}>
        This isn't a live chat — please don't expect an instant reply. Our team typically responds within 1-2 business days.
      </p>
      {error && <p className="login-error" style={{ color: "red" }}>{error}</p>}
      <textarea
        rows="4"
        placeholder="Type your message…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        style={{ width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #ddd", marginBottom: "10px", resize: "vertical" }}
      />
      <button type="submit" className="submit-visit-btn" disabled={sending}>
        {sending ? "Sending…" : "Send Message"}
      </button>
    </form>
  );
}

function Contact() {
  return (
    <>
      <Navbar />
      <Sidebar />

      <div className="main-content">
        <div className="visit-card" style={{ marginBottom: "20px" }}>
          <h1>Get in Touch</h1>
          <p style={{ color: "#666", marginTop: "-8px" }}>We're here to help with anything Jain Farms</p>

          <p style={{ fontSize: "11px", fontWeight: 800, color: "#888", letterSpacing: "0.6px", margin: "18px 0 8px" }}>
            SEND US A MESSAGE
          </p>
          <SendMessageCard />
        </div>

        <div className="visit-card" style={{ marginBottom: "20px" }}>
          <p style={{ fontSize: "11px", fontWeight: 800, color: "#888", letterSpacing: "0.6px", margin: "0 0 10px" }}>
            CALL US
          </p>
          {PHONE_NUMBERS.map((p) => (
            <div
              key={p.label}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #eee" }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <FaPhoneAlt color="#2e7d32" />
                <span>
                  <div style={{ fontSize: "12px", color: "#888" }}>{p.label}</div>
                  <div style={{ fontWeight: 600 }}>{p.number}</div>
                </span>
              </span>
              <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <a
                  href={`tel:${p.number.replace(/\s/g, "")}`}
                  title="Call"
                  style={{
                    display: "flex", alignItems: "center", justifyContent: "center",
                    width: "34px", height: "34px", borderRadius: "17px", background: "#2e7d3222",
                    color: "#2e7d32", textDecoration: "none",
                  }}
                >
                  <FaPhoneAlt size={14} />
                </a>
                {p.whatsapp && (
                  <a
                    href={`https://wa.me/${p.whatsapp}?text=${encodeURIComponent("Hello Jain Farms, ")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="WhatsApp"
                    style={{
                      display: "flex", alignItems: "center", justifyContent: "center",
                      width: "34px", height: "34px", borderRadius: "17px", background: "#25D36622",
                      color: "#25D366", textDecoration: "none",
                    }}
                  >
                    <FaWhatsapp size={16} />
                  </a>
                )}
              </span>
            </div>
          ))}
        </div>

        <div className="visit-card" style={{ marginBottom: "20px" }}>
          <p style={{ fontSize: "11px", fontWeight: 800, color: "#888", letterSpacing: "0.6px", margin: "0 0 10px" }}>
            EMAIL US
          </p>
          {EMAILS.map((e) => (
            <a
              key={e.label}
              href={`mailto:${e.address}`}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #eee", textDecoration: "none", color: "inherit" }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <FaEnvelope color="#2e7d32" />
                <span>
                  <div style={{ fontSize: "12px", color: "#888" }}>{e.label}</div>
                  <div style={{ fontWeight: 600 }}>{e.address}</div>
                </span>
              </span>
              <span style={{ color: "#999", fontSize: "20px" }}>›</span>
            </a>
          ))}
        </div>

        <div className="visit-card" style={{ marginBottom: "20px" }}>
          <p style={{ fontSize: "11px", fontWeight: 800, color: "#888", letterSpacing: "0.6px", margin: "0 0 10px" }}>
            HEAD OFFICE
          </p>
          <a
            href="https://maps.app.goo.gl/TkfwcrKPJSTzNrCf7?g_st=com.google.maps.preview.copy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", gap: "10px", textDecoration: "none", color: "inherit" }}
          >
            <FaMapMarkerAlt color="#2e7d32" style={{ marginTop: "3px", flexShrink: 0 }} />
            <span>{ADDRESS}</span>
          </a>
        </div>

        <div className="visit-card">
          <p style={{ fontSize: "11px", fontWeight: 800, color: "#888", letterSpacing: "0.6px", margin: "0 0 14px" }}>
            FOLLOW US
          </p>
          <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "70px", textDecoration: "none", color: "#333" }}
              >
                <span
                  style={{
                    width: "44px", height: "44px", borderRadius: "22px", display: "flex",
                    alignItems: "center", justifyContent: "center", background: s.color + "22",
                    color: s.color, fontSize: "18px", marginBottom: "6px",
                  }}
                >
                  {s.icon}
                </span>
                <span style={{ fontSize: "11px", fontWeight: 600 }}>{s.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
